const form = {
  formId: "new-user-form",
  formField: {
    sellerName: {
      name: "sellerName",
      label: "Tên người bán",
      type: "text",
      placeholder: "Tên người bán",
      errorMsg: "Vui lòng nhập tên người bán",
    },
    sellerTaxCode: {
      name: "sellerTaxCode",
      label: "Mã số thuế người bán",
      type: "text",
      placeholder: "10900091-01",
      errorMsg: "Vui lòng nhập mã số thuế người bán",
    },
    sellerPhone: {
      name: "sellerPhone",
      label: "Số điện thoại người bán",
      type: "text",
      placeholder: "0900900901",
      errorMsg: "Vui lòng nhập số điện thoại người bán",
    },
    sellerAddress: {
      name: "sellerAddress",
      label: "Địa chỉ người bán",
      type: "text",
      placeholder: "12/23b Ninh Kiều Cần thơ",
      errorMsg: "Vui lòng nhập địa chỉ người bán",
    },
    sellerBankAccount: {
      name: "sellerBankAccount",
      label: "Số tài khoản người bán",
      type: "text",
      placeholder: "21331231231231223",
      errorMsg: "Vui lòng nhập số tài khoản người bán",
    },
    buyerName: {
      name: "buyerName",
      label: "Tên người mua",
      type: "text",
      placeholder: "Tên người mua",
      errorMsg: "Vui lòng nhập tên người mua",
    },
    buyerTaxCode: {
      name: "buyerTaxCode",
      label: "Mã số thuế người mua",
      type: "text",
      placeholder: "10900091-01",
      errorMsg: "Vui lòng nhập mã số thuế người mua",
    },
    buyerAddress: {
      name: "buyerAddress",
      label: "Địa chỉ người mua",
      type: "text",
      placeholder: "12/23b Ninh Kiều Cần thơ",
      errorMsg: "Vui lòng nhập địa chỉ người mua",
    },
    buyerBankAccount: {
      name: "buyerBankAccount",
      label: "Số tài khoản người mua",
      type: "text",
      placeholder: "21331231231231223",
      errorMsg: "Vui lòng nhập số tài khoản người mua",
    },
    day: {
      name: "day",
      label: "Ngày xuất hóa đơn",
      type: "number",
      errorMsg: "Vui lòng chọn ngày xuất hóa đơn",
    },
    payments: {
      name: "payments",
      label: "Hình thức thanh toán",
      type: "text",
      errorMsg: "Vui lòng nhập chọn hình thức thanh toán",
    },
    currency: {
      name: "currency",
      label: "Đồng tiền thanh toán",
      type: "text",
      placeholder: "VNĐ",
      errorMsg: "Vui lòng nhập loại tiền thanh toán",
    },
    invoiceSymbol: {
      name: "invoiceSymbol",
      label: "Mã hóa đơn",
      type: "text",
      placeholder: "1A2B3C",
    },
    number: {
      name: "number",
      label: "Số hóa đơn",
      type: "number",
      placeholder: "0",
    },
  },
};

export default form;
